// extracted by mini-css-extract-plugin
export default {"container":"tTdk1c"};